import DynamicTextComponent from "@baseUI/component/text/DynamicTextComponent";
import UIFacade from "@baseUI/UIFacade";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import AddComponent from "@base/utils/AddComponent";
import UISignals from "@baseUI/controllers/UISignals";

export default class Paytable {

    constructor(parent, settings = {}) {
        this.parent = parent
        this.containers = {};
        this.settings = settings;
    }

    init() {
        super.init()
    }

    build() {
        this.rows = UIFacade.Paytable.rows
        this.createSymbols()
        this.createValues()
        UISignals.currentBetIndexHasChanged.add(this.updateValues, this)
    }

    createSymbols() {
        for (const row of this.rows) {
            const rowContainer = UICreatorComponent.addContainer(this.parent, {x: row.x, y: row.y});

            for (let i = 0; i < row.symbols.length; i++) {
                const symbol = row.symbols[i];
                let x = 0;
                if(row.symbols.length === 1){
                    x = (this.settings.width / 2) - (UIFacade.Paytable.symbolWidth / 2);
                }else{
                    x = (this.settings.width / (row.symbols.length - 1) * i);
                    if (i === row.symbols.length - 1) {
                        x = x - UIFacade.Paytable.symbolWidth
                    } else if (i !== 0) {
                        x = x - (UIFacade.Paytable.symbolWidth / 2)
                    }
                }


                const symbolContainer = UICreatorComponent.addContainer(rowContainer, {x: x, y: 0});
                AddComponent.addElement(symbol.imagePath, symbolContainer, [0, 0], '', 1.25)

                this.containers[symbol.id] = symbolContainer;
            }
        }
    }

    createValues() {
        this.values = new Map()
        for (const row of this.rows) {
            for (const symbol of row.symbols) {
                const payouts = UIFacade.model.paytable[symbol.id];
                for (let j = payouts.length - 1; j >= 0; j--) {
                    if (payouts[j] === 0) {
                        continue;
                    }

                    const value = new DynamicTextComponent('paytableValue', 'paytableValue')
                    const bet = UIFacade.model.betsValues[UIFacade.model.currentBetIndex]
                    const currency = UIFacade.model.currency
                    const toFixed = UIFacade.model.toFixed
                    let symbolsCount = payouts[j].count;

                    if(symbol.id !== 14010){
                        if (symbolsCount >= 11) {
                            value.symbolsCount = `${symbolsCount}+`;
                        } else {
                            value.symbolsCount = `${symbolsCount}-${symbolsCount + 1}`;
                        }
                    }else{
                        value.symbolsCount = symbolsCount
                    }


                    value.localizedPIXIText.text = `${value.symbolsCount} | ${currency} ${Number(bet * payouts[j].multiplier).toFixed(toFixed)}`
                    this.values.set(value, payouts[j].multiplier)

                    value.y = UIFacade.Paytable.symbolValuesStartingY + (UIFacade.Paytable.symbolValuesGap * j);
                    this.containers[symbol.id].addChild(value);
                }
            }
        }
    }

    updateValues() {
        const bet = UIFacade.model.betsValues[UIFacade.model.currentBetIndex]
        const currency = UIFacade.model.currency
        const toFixed = UIFacade.model.toFixed

        for (let value of this.values.keys()) {
            const k = this.values.get(value)
            value.localizedPIXIText.text = `${value.symbolsCount} | ${currency} ${Number(bet * k).toFixed(toFixed)}`
        }
    }
}
